import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root',
})
export default class RoutesserviceService {

  public BASE_URL = `${environment.apiBaseUrl}`;
  public BASE_URL_admin_api = `${environment.apiBaseUrlAdmin}`;

  constructor(
    private httpClient: HttpClient,
  ) { }

  //LEave management API
  getLeaveMangement() {
    return this.BASE_URL_admin_api + '/api/get-all-leaves';
  }
  //get screenshot from tracker
  getScreenShotFromTracker() {
    return this.BASE_URL + '/screenShotForSpecificDay';
  }

  backfillSingleUser() {
    return this.BASE_URL + '/backfill-single-user';
  }

  // leave Report Current year Last year
  leaveReport() {
    return this.BASE_URL + `/leave-report`;

  }




  //leaves Reset
  resetLeaves() {
    return this.BASE_URL + '/reset-leaves';

  }
  // LeaveApproved
  leaveApproved() {
    return this.BASE_URL + `/accept-leave`;
  }
  // reject Leave with 2 param
  leaveReject() {
    return this.BASE_URL + '/reject-leave';

  }
  //Auth routes are here
  getLogin() {
    return this.BASE_URL + '/login';
  }

  // 2FA endpoints
  get2FASetup() {
    return this.BASE_URL + '/2fa/setup';
  }

  get2FAVerify() {
    return this.BASE_URL + '/2fa/verify';
  }

  get2FAEnable() {
    return this.BASE_URL + '/2fa/enable';
  }

  get2FAValidate() {
    return this.BASE_URL + '/2fa/validate';
  }

  get2FASetupLogin() {
    return this.BASE_URL + '/2fa/setup-login';
  }

  getAuthVerifyOtp() {
    return this.BASE_URL + '/auth/verify-otp';
  }

   resetAuth(){
     return this.BASE_URL + '/2fa/reset';
  }

  resetUser2FA(){
    return this.BASE_URL + '/2fa/reset-user';
  }

  enableUser2FA(){
     return this.BASE_URL + '/2fa/enable-user';
  }

  fetchUserSalary(){
    return this.BASE_URL + '/get-user-salary';
  }
  getcurrentMonthSalaries(){
     return this.BASE_URL + '/all-employyee-processing';
  }
  getLogout() {
    return this.BASE_URL + '/logout';
  }

  recoverPassword() {
    return this.BASE_URL + '/recover-password';
  }
  checkPin() {
    return this.BASE_URL + '/check_pincode';
  }
  otpSend() {
    return this.BASE_URL + '/send-otp';
  }
  verifyOtp() {
    return this.BASE_URL + '/verify-otp';
  }

  newPin(){
    return this.BASE_URL + '/set-pincode';
  }


  setShiftTime(){
    return this.BASE_URL + '/set-shift-time';
  }


  recoverPinCode() {
    return this.BASE_URL + '/recover-pincode';
  }

  // policies routes are here
  getpolicies() {
    return this.BASE_URL + '/get-policies';
  }

  getPoliciesFilter() {
    return this.BASE_URL + '/filter-policies';
  }

  // attendance routes are here

  attendanceCorrection() {
    return this.BASE_URL + '/attendance-correction-req';
  }
  getAttendance() {
    return this.BASE_URL + '/get-attendance';
  }
  getUserAttendance() {
    return this.BASE_URL + '/get-user-attendance';
  }

  getAttendanceFilters() {
    return this.BASE_URL + '/filter-attendance';
  }

  getFilterByDate() {
    return this.BASE_URL + '/user-attendance-filter';

  }
  getFilterAttedance() {
    return this.BASE_URL + '/get-all-attendance';
  }

  // get attendance change request
  getAttndancerequest() {
    return this.BASE_URL + '/attendance-correction-data';
  }

  getAttendanceReports() {
    return this.BASE_URL + '/attendance-reports';
  }

  // get attandance request daa munib
  getAttendanceRequestData() {
    return this.BASE_URL + '/attendance-req-data';
  }

  // get my attendance corrections
  getMyAttendanceCorrections() {
    return this.BASE_URL + '/user-attendance-correction';
  }
  deleteAttendance(){
    return this.BASE_URL + '/user-attendance-delete';
  }


  //loanDeatail
  getLoanDetail(id: any) {
    return this.BASE_URL + `/loan-details/${id}`;
  }
  // approved api attendance correction table save data

  getapprove() {
    return this.BASE_URL + '/get-approve-attendance';
  }

  //loan filter
  filterReq() {
    return this.BASE_URL + '/loan-req-filter';
  }


  //notifications

  showNotify() {
    return this.BASE_URL + '/show-request-count';
  }

  getFilterByName() {
    return this.BASE_URL + `/attendance-request-filter`;
  }

  //Employee add routes are here munib
  getAdd() {
    return this.BASE_URL + '/create-user';

  }
  // delete User

  userDelete(uuid: string) {
    return this.BASE_URL + `/delete-user/${uuid}`;
  }

  userRetrived(uuid: string) {
    return this.BASE_URL + `/retrive-user/${uuid}`;
  }

  userUpdate(uuid: string) {

    return this.BASE_URL + `/get-user/${uuid}`;
  }


  userdetail() {
    return this.BASE_URL + '/user-detail';
  }
  getleavetype() {
    return this.BASE_URL + '/leave_type';
  }
  userrefresh() {
    return this.BASE_URL + '/recheckdata';
  }
  employeesdetail() {
    return this.BASE_URL + '/user-counts';
  }
  employeesevaluation() {
    return this.BASE_URL + '/top-evaluation';
  }
  setattendance() {
    return this.BASE_URL + '/set-attendance';
  }


  settodayattendance() {
    return this.BASE_URL + '/set-today-attendance';
  }


  cardsImages() {
    return this.BASE_URL + '/get-cards';
  }
  // sheet uplaoad

  atendanceuploadsheet() {
    return this.BASE_URL + '/import-attendance-files';
  }

  // event  Managment System


  geteventRequest() {
    return this.BASE_URL + '/create-event';
  }

  //Show event details API


  showEvents() {
    return this.BASE_URL + '/show-events';

  }
  showEventDetail() {
    return this.BASE_URL + '/show-event-detail';

  }

  aproveselecteddata() {
    return this.BASE_URL + '/approve-selected';
  }

  rejectselecteddata() {
    return this.BASE_URL + '/reject-selected';
  }
  approveallReq() {
    return this.BASE_URL + '/aprove-all';
  }
  rejectallReq() {
    return this.BASE_URL + '/reject-all';
  }

  modeColor() {
    return this.BASE_URL + '/change-theme';
  }



  // user role -section
  addRole() {
    return this.BASE_URL + '/create-user-roles';
  }

  getUserRole() {
    return this.BASE_URL + '/get-user-roles';
  }

  deleteRole() {
    return this.BASE_URL + '/delete-user-roles';
  }

 



  getevent() {
    return this.BASE_URL + '/upcomming-event-detail';
  }



  deleteEvents() {
    return this.BASE_URL + '/delete-event';
  }




  // quick changing
  // password
  getChangepassword() {
    return this.BASE_URL + `/change-password`;
  }
  // status
  getChangeStatus() {
    return this.BASE_URL + `/change-status`;
  }
  // shift time
  getChangeShiftTime() {
    return this.BASE_URL + `/change-shif-time`;
  }
  // Account No
  getChangeAccountNo() {
    return this.BASE_URL + `/change-bank-account`;
  }

  // Salary
  getChangeSalary() {
    return this.BASE_URL + `/change-salary`;
  }


  // loan Request
  getLoanRequest() {
    return this.BASE_URL + `/loan-request`;
  }


  // get teamlead data

  teamLeadData(department: any) {
    return this.BASE_URL + `/get-team?department=${department}`;
  }

  // get loans data
  getLoanData() {
    return this.BASE_URL + `/show-loans`;
  }


  // approved loan
  loanApproved() {
    return this.BASE_URL + `/loan-status`;
  }


  getStaticData() {
    return this.BASE_URL + '/get_data';
  }

  //Leave routes are here
  getApplyLeave() {
    return this.BASE_URL + '/apply-leave';
  }
  getCheckLeaveLimit() {
    return this.BASE_URL + '/check-monthly-limit';
  }
  leaveModifiDate() {
    return this.BASE_URL + '/get-keys';
  }


  getUpdateLeave() {
    return this.BASE_URL + '/update-leave';
  }

  getDeleteLeave() {
    return this.BASE_URL + '/delete-leave';
  }

  getAllLeave() {
    return this.BASE_URL + '/get-leaves';
  }
  getAllUserLeave() {
    return this.BASE_URL + '/all_leaves';
  }
  getLeaveFilters() {
    return this.BASE_URL + '/filter-leave';
  }
  leaveupdate() {
    return this.BASE_URL + '/update-leave-date';
  }

  leaveredo() {
    return this.BASE_URL + '/redo-leave';
  }

  getAbsents() {
    return this.BASE_URL + '/get-absents';
  }
  leaveFilter() {
    return this.BASE_URL + '/filter-user-leave';
  }


  getcheckapplyLeave() {
    return this.BASE_URL + '/user-leave-check';
  }
  //Payroll Routes are here

  getAllPayroll() {
    return this.BASE_URL + '/get-payroll';
  }

  getPayrollFilters() {
    return this.BASE_URL + '/filter-payroll';
  }

  getPaySlipData() {
    return this.BASE_URL + '/get-payslip-data';
  }
  getLoan(id: any) {
    return this.BASE_URL + `/user-loan-request/${id}`;
  }

  getpaySummary(type: any, year?: any) {
    return this.BASE_URL + `/get-user-payhistory?type=${type}` + (year ? `&year=${year}` : '');
  }

  // update loan
  getUpdateLoan() {
    return this.BASE_URL + `/edit-loan-request`;
  }

  // user loan requests
  getUserLoans() {
    return this.BASE_URL + '/show-user-loans';
  }

  // Delete Loan
  getDelateLoan() {
    return this.BASE_URL + '/delete-loan-request';
  }


  getHolidays() {
    return this.BASE_URL + '/getHolidays';
  }

  addHoliday() {
    return this.BASE_URL + '/addHoliday';
  }

  //Notes Routes are here

  getAllNotes() {
    return this.BASE_URL + `/get-notes`;
  }
  uploadImage() {
    return this.BASE_URL_admin_api + `/api/upload-file`;
  }

  getNotesFilters() {
    return this.BASE_URL + `/filter-notes`;
  }



  // all user attendance

  userAttendance() {
    return this.BASE_URL + `/user-attendance`;
  }

  // user attendance Detail


  attendanceDetail() {
    return this.BASE_URL + `/user-attendance-detail`;
  }


  // update Attendance

  getUpateAttendance() {
    return this.BASE_URL + `/change-attendance`;
  }

  getBulkUpdateAttendance() {
    return this.BASE_URL + `/bulk-change-attendance`;
  }

  //evaluation routes
  getAllEvaluations() {
    return this.BASE_URL + '/get-evaluation';
  }

  getEmployeeEvaluations() {
    return this.BASE_URL + '/get-employee-evaluations';
  }

  getAllEvaluationsFilter() {
    return this.BASE_URL + '/filter-evaluation';
  }

  getAllEvaluationsDetails() {
    return this.BASE_URL + '/get-evaluation-details';
  }

  getEvaluationCountByMonth() {
    return this.BASE_URL + '/get-evaluation-by-month';
  }
  latestEvaluation() {
    return this.BASE_URL + '/get-latest-evaluation';
  }
  getAttendanceStats() {
    return this.BASE_URL + '/get-attendance-stats';
  }

  getLeaveStats() {
    return this.BASE_URL + '/get-leave-stats';
  }

  getKPVList() {
    return this.BASE_URL + '/get-kps-list-admin';
  }

  addOrUpdateKPV() {
    return this.BASE_URL + '/add-new-evaluation-admin';
  }

  getAllUsersEvaluationAdmin() {
    return this.BASE_URL + '/get-all-users-evaluation-admin';
  }

  AllUsersEvaluationteam() {
    return this.BASE_URL + '/get-team-evaluation';
  }


  getUseranualEvaluation() {
    return this.BASE_URL + '/team-anual-evaluation';
  }

  getEvaluation() {
    return this.BASE_URL + '/get-user-evaluation';
  }

  publish() {
    return this.BASE_URL + '/publish-all-evaluations';
  }

  getAllUsers() {
    return this.BASE_URL + '/get-users-evaluation';
  }
  addBulkEvaluation() {
    return this.BASE_URL + '/add-bulk-evaluation';
  }
  //Dashboard API

  getDashboard() {
    return this.BASE_URL + '/dashboard';
  }

  getUserList() {
    return this.BASE_URL + '/get-users';
  }

  deleteMedia() {
    return this.BASE_URL + '/delete-media';
  }
  getWFH() {
    return this.BASE_URL + '/update-wfh-portal';
  }


  getAllMonthSalaries() {
    return this.BASE_URL + '/all-employyee-salaries';
  }

  getUserAllSalries() {
    return this.BASE_URL + '/get-user-all-salaries-admin';
  }

  getUserSalryDetail() {
    return this.BASE_URL + '/get-salary-complete-details-admin';
  }
  assignNewSallary() {
    return this.BASE_URL + '/assign-new-salary-admin';
  }

  saveGenratedSalary() {
    return this.BASE_URL + '/update-employee-salary-admin';
  }
  upldateLoanCounter() {
    return this.BASE_URL + '/change-loan-counter';
  }
  getTodayAttendanceCheck() {
    return this.BASE_URL + '/get-today-check-in';
  }

  checkOutFromPortal() {
    return this.BASE_URL + '/add-checkout-portal';
  }
  leaveCount() {
    return this.BASE_URL + '/leave_count';
  }

  checkInFromPortal() {
    return this.BASE_URL + '/add-checkout-portal';
  }

  checkuserrefresh() {
    return this.BASE_URL + '/recheckdata';
  }

  leaveotherusers() {
    return this.BASE_URL + '/other_leave';
  }
  RemainingLeaves() {
    return this.BASE_URL + '/user_remaining_leave';
  }
  UserremainingLeaves() {
    return this.BASE_URL + '/current_user_leave';
  }
  themeChange() {
    return this.BASE_URL + '/theme-change';
  }
  passwordReset() {
    return this.BASE_URL + '/password-reset';
  }
  pinReset() {
    return this.BASE_URL + '/picode-reset';
  }

  getOrgnizations() {
    return this.BASE_URL + '/get-orgnizations';
  }
  changeOrg() {
    return this.BASE_URL + '/change-organization';
  }

  // ammount api's

  addamount() {
    return this.BASE_URL + '/add-account-data';
  }
  getAmount() {
    return this.BASE_URL + '/get-user-account-data';
  }
  getadmindeail(id: any) {
    return this.BASE_URL + `/account-admin-detail?id=${id}`;
  }
  getadmins() {
    return this.BASE_URL + '/account-alldata';
  }
  getchart() {
    return this.BASE_URL + '/account-chart';
  }
  gettrasaction() {
    return this.BASE_URL + '/user-account-calculation';
  }

  getadminAll() {
    return this.BASE_URL + '/admin-all-data';
  }

  getadmintrasaction(id: any) {
    return this.BASE_URL + `/admin-chart-detail?id=${id}`;
  }
  getreservecal() {
    return this.BASE_URL + '/user-reserve-calculation';
  }
  getupdateaccount() {
    return this.BASE_URL + '/account-edit';
  }
  getdeleteaccount() {
    return this.BASE_URL + '/account-delete';
  }
  getfilteraccount() {
    return this.BASE_URL + '/account-Filter';
  }
  getdeleteorg() {
    return this.BASE_URL + '/delete-organization';
  }
  getCatAll() {
    return this.BASE_URL + '/get-SubCategory';
  }


  // setting management
  getType() {
    return this.BASE_URL + '/get-type';
  }
  createTextAutomation() {
    return this.BASE_URL + '/create-automatedTemplate';
  }
  editTextAutomation() {
    return this.BASE_URL + '/edit-automatedTemplate';
  }
  deleteTextAutomation() {
    return this.BASE_URL + '/delete-automatedTemplate';
  }
  getTextAutomation() {
    return this.BASE_URL + '/get-automatedTemplate';
  }
  setOrgData() {
    return this.BASE_URL + '/create-organization';
  }
  editorg() {
    return this.BASE_URL + '/edit-organization';
  }

  getOrgData() {
    return this.BASE_URL + '/get-organization';
  }


  setDesData() {
    return this.BASE_URL + '/create-designation';
  }

  editDesData() {
    return this.BASE_URL + '/edit-designation';
  }

  getDesData() {
    return this.BASE_URL + '/get-designation';
  }

  getdeletedes() {
    return this.BASE_URL + '/delete-designation';
  }

  // department


  getdepData() {
    return this.BASE_URL + '/get-department';
  }
  setdepData() {
    return this.BASE_URL + '/create-department';
  }
  editDepData() {
    return this.BASE_URL + '/edit-department';
  }
  getdeletedep() {
    return this.BASE_URL + '/delete-department'
  }

  // policy

  setpolicyData() {
    return this.BASE_URL + '/add-policies';
  }
  getpolicyData() {
    return this.BASE_URL + '/get-policies';
  }
  getpolicy() {
    return this.BASE_URL + '/get-policy';
  }

  editpolciData() {
    return this.BASE_URL + '/update-policies';
  }

  getdeletpolicy() {
    return this.BASE_URL + '/delete-policies';

  }

  // category

  setcategoryData() {
    return this.BASE_URL + '/create-category';
  }
  getcategoryData() {
    return this.BASE_URL + '/get-category';
  }
  editcategoryData() {
    return this.BASE_URL + '/edit-category';
  }
  getdeletcategory() {
    return this.BASE_URL + '/delete-category';
  }


  // sub category

  getSubCategoryData() {
    return this.BASE_URL + '/get-SubCategory';
  }

  setsubcategoryData() {
    return this.BASE_URL + '/create-subcategory';
  }

  editsubcategoryData() {
    return this.BASE_URL + '/edit-subcategory';
  }
  getdeletsubcategory() {
    return this.BASE_URL + '/delete-subcategory';
  }
  addleave() {
    return this.BASE_URL + '/set-leaves';
  }
  getleavesData() {
    return this.BASE_URL + '/get-set-leaves';
  }
  getdeleteleave() {
    return this.BASE_URL + '/delete-set-leaves';
  }

  addkeys() {
    return this.BASE_URL + '/get-set-keys';
  }
  getkeysData() {
    return this.BASE_URL + '/get-keys';
  }
  getdeletekey() {
    return this.BASE_URL + '/delete-keys';
  }

  getkpsData() {
    return this.BASE_URL + '/get-kpslist';
  }
  addkps() {
    return this.BASE_URL + '/add-kpslist';
  }
  deletekps() {
    return this.BASE_URL + '/delete-kpslist';
  }
  editkps() {
    return this.BASE_URL + '/edit-kpslist';
  }




  // new admin dashboard

  punchinlogs() {
    return this.BASE_URL + '/admin-punchin-detail';
  }

  punchoutlogs() {
    return this.BASE_URL + '/admin-punchout-detail';
  }
  attendancetlogs() {
    return this.BASE_URL + '/admin-attendance-detail';
  }
  getLeaveslog() {
    return this.BASE_URL + '/admin-leave-detail';
  }
  headCounts() {
    return this.BASE_URL + '/admin-head-counts';
  }
  requestData() {
    return this.BASE_URL + '/admin-request-count';
  }

  // notification

  adminNotification() {
    return this.BASE_URL + '/admin-notifications';
  }

  NotificationClear() {
    return this.BASE_URL + '/clear-notifications';
  }
  singleNotification() {
    return this.BASE_URL + '/read-notification';

  }
  leaveNotify() {
    return this.BASE_URL + '/get-leave-notification';
  }

  getAttendanceId() {
    return this.BASE_URL + '/get-attendance-id';
  }
  // announcement mangement
  createCategory() {
    return this.BASE_URL + '/categories';
  }
  getCategory() {
    return this.BASE_URL + '/get-categories';
  }
  addAnnouncement() {
    return this.BASE_URL + '/add-announcement';
  }
  editAnnouncement() {
    return this.BASE_URL + '/edit-announcement';
  }
  getAnnouncements() {
    return this.BASE_URL + '/get-announcements';
  }
  getOneAnnouncementForEdit(id: any) {
    return this.BASE_URL + `/get-one-announcements/${id}`;
  }
  deleteAnnouncements() {
    return this.BASE_URL + '/delete-announcements';
  }

  latestAnnouncement() {
    return this.BASE_URL + '/get-latest-announcement';
  }

  addReactionAnnouncements() {
    return this.BASE_URL + '/add-reaction-announcement';
  }

  upcomingSalary() {
    return this.BASE_URL + '/employee-next-salary';
  }

  addressSugestion(query:any) {
    return this.BASE_URL + `/places-suggestions?query=${query}`;
  }
  addressdetail(query:any){
    return this.BASE_URL + `/places-details?place_id=${query}`;
  }




 updateProfileImage() {
    return this.BASE_URL + '/update-profileimg';
  }

addSeeder(){
    return this.BASE_URL + '/add-demoSeeder';
}

  getpayrollSummary(){
    return this.BASE_URL + '/get-payroll-summary';
  }

  getyearlyPayroll(){
    return this.BASE_URL + '/payroll-yearly';
  }

  getdepartmetPayroll(){
    return this.BASE_URL + '/department-summary';
  }

  getMonthlyPayroll(){
     return this.BASE_URL + '/monthly-payroll';
  }

  generatePayroll(){
     return this.BASE_URL + '/generate-all-payroll';
  }

getPayrollProgress(monthInt: number, year: number): string {
  return this.BASE_URL + `/progress/${monthInt}/${year}`;
}


generateSelectedPayroll(){
     return this.BASE_URL + '/change-payroll-status';
  }


  
  bulkActionPayroll(){
    return this.BASE_URL + '/bulk-action-payroll';
  }


  generateUserSalary(){
    return this.BASE_URL + '/genrate-user-salary';
  }

   updateUserSalary(){
    return this.BASE_URL + '/update-user-salary';
  }
  
   getCounts(){
    return this.BASE_URL + '/get-counts';
  }

  getuserDetailList(){
    return this.BASE_URL + '/get-user-pays';
  }
  getAllAdmins(){
    return this.BASE_URL + '/get-admins';
  }

   sendMailAdmin(){
    return this.BASE_URL + '/send-monthly-review';
  }

  getuserHistory(){
    return this.BASE_URL + '/user-payroll-detail';
  }

  getReviewCheck(){
    return this.BASE_URL + '/check-monthly-review';
  }

  sendReviewChanges(){
    return this.BASE_URL + '/send-change-review';
  }
  approvePayroll(){
     return this.BASE_URL + '/approved-review';
  }

  addPayrollEntry(){
    return this.BASE_URL + '/create-empty-salary';
  }
  checkReview(){
    return this.BASE_URL + '/check-review-payroll';
  }
  getPayrollMonth(){
    return this.BASE_URL + '/get-monthly-total-Payrol';
  }
  getmonthSalary(){
    return this.BASE_URL + '/check-monthly-salary';
  }
  getdetailmonthSalary(){
     return this.BASE_URL + '/get-monthly-payroll';
  }
}
